import { cn } from '@/lib/utils'
import { forwardRef } from 'react'

const Skeleton = forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            {...props}
            className={cn(
                'size-full flex flex-grow',
                'animate-pulse bg-gray-200 dark:bg-gray-600 rounded-md',
                className,
            )}
        />
    )
})

Skeleton.displayName = 'Skeleton'

export default Skeleton
